import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	WeeklyGameDTO,
	WeekTreasureFilter,
} from '../DTO/exchange/weekTreasure.interface';

export const weekTreasureApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getWeekTreasureList: builder.query<
			SuccessResponse<Paginated<WeeklyGameDTO>>,
			WeekTreasureFilter
		>({
			query: (body) => ({
				url: `/web/weekly-game/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['WeekTreasureList'],
		}),
		getWeekTreasureSortList: builder.query<
			SuccessResponse<WeeklyGameDTO[]>,
			null
		>({
			query: () => ({
				url: `/web/weekly-game/sort`,
				method: 'GET',
			}),
		}),
		sortWeekTreasureSortList: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/weekly-game/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WeekTreasureList'],
		}),
		updateWeekTreasure: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/weekly-game`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WeekTreasureList'],
		}),
		resetWeekTreasure: builder.mutation<SuccessResponse<any>, null>({
			query: () => ({
				url: `/web/weekly-game/refresh`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetWeekTreasureListQuery,
	useGetWeekTreasureSortListQuery,
	useSortWeekTreasureSortListMutation,
	useUpdateWeekTreasureMutation,
	useResetWeekTreasureMutation,
} = weekTreasureApiSlice;
